import { ArrowDown } from 'lucide-react';
import { WHATSAPP_URL, DOCTOR_PHOTO_HERO } from '../constants';
import { useCountUp } from '../hooks/useCountUp';

function StatNumber({ target, suffix }) {
  const [ref, count] = useCountUp(target);
  return <span ref={ref} className="font-poppins font-bold text-3xl text-[#0D47A1]">{count}{suffix}</span>;
}

export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center pt-16 overflow-hidden"
      style={{
        backgroundImage: 'url(/images/hospital_bg.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center top'
      }}>

      {/* Light overlay for text readability */}
      <div className="absolute inset-0 bg-white/60 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 lg:px-8 w-full py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          {/* Text Content — dark on light bg */}
          <div className="order-2 lg:order-1">
            <div className="inline-flex items-center bg-[#0D47A1]/8 border border-[#0D47A1]/20 rounded-full px-4 py-1.5 text-sm font-semibold text-[#0D47A1] mb-6">
              Cirurgião Torácico · Feira de Santana, BA
            </div>

            <h1 className="font-poppins font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight mb-4 text-[#0D47A1]">
              Livre-se da Hiperidrose <span className="text-[#00897B]">com a Simpatectomia</span>
            </h1>

            <p className="text-lg md:text-xl text-[#212121]/80 mb-5 font-semibold leading-snug">
              Técnica cirúrgica minimamente invasiva com 95% de eficácia.
              Recuperação rápida. Vida normal em poucos dias.
            </p>

            <p className="text-base md:text-lg text-[#212121]/60 mb-8 leading-relaxed max-w-lg">Seu suor excessivo não é apenas um problema estético, é um problema de qualidade de vida. Eu sei que você evita contato, troca de roupa várias vezes no dia e perdeu momentos importantes por causa disso. Existem soluções que não resolvem. Existe uma que funciona: a cirurgia de Simpatectomia. E você a encontrou aqui.



            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-primary-cta"
                className="bg-[#0D47A1] text-white font-poppins font-bold px-8 py-4 rounded-full hover:bg-[#00897B] transition-all duration-200 text-center shadow-lg hover:shadow-xl hover:-translate-y-0.5">

                QUERO FICAR LIVRE DISSO
              </a>
              <a
                href="#procedimento"
                data-testid="hero-secondary-cta"
                className="text-[#0D47A1] border-2 border-[#0D47A1]/30 font-poppins font-semibold px-8 py-4 rounded-full hover:bg-[#0D47A1]/8 hover:border-[#0D47A1]/60 transition-all duration-200 text-center flex items-center justify-center gap-2">

                Veja como funciona
                <ArrowDown size={16} />
              </a>
            </div>

            {/* Stats */}
            <div className="flex gap-8 pt-8 border-t border-[#0D47A1]/15">
              <div>
                <StatNumber target={150} suffix="+" />
                <div className="text-[#212121]/50 text-sm">Procedimentos</div>
              </div>
              <div>
                <StatNumber target={95} suffix="%" />
                <div className="text-[#212121]/50 text-sm">Taxa de satisfação</div>
              </div>
              <div>
                <div className="font-poppins font-bold text-3xl text-[#0D47A1]">3-5 dias</div>
                <div className="text-[#212121]/50 text-sm">Recuperação</div>
              </div>
            </div>
          </div>

          {/* Doctor Photo */}
          <div className="relative order-1 lg:order-2 flex justify-center lg:justify-end items-end">
            <div className="relative w-full max-w-sm lg:max-w-xl">
              <img
                src={DOCTOR_PHOTO_HERO}
                alt="Dr. Mateus Marques - Cirurgião Torácico"
                className="w-full object-contain object-bottom"
                style={{ maxHeight: '680px', filter: 'drop-shadow(0 20px 60px rgba(13,71,161,0.15))' }}
                loading="eager"
                fetchpriority="high"
                decoding="sync" />

              {/* Floating badges */}
              <div className="absolute bottom-16 -left-4 bg-white rounded-2xl p-4 shadow-xl border border-gray-100">
                <div className="font-poppins font-bold text-2xl text-[#0D47A1]">95%</div>
                <div className="text-[#212121]/60 text-xs font-medium">de eficácia</div>
              </div>
              <div className="absolute top-8 -right-2 bg-[#00897B] rounded-2xl p-4 shadow-xl">
                <div className="font-poppins font-bold text-2xl text-white">150+</div>
                <div className="text-white/80 text-xs font-medium">simpatectomias</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>);

}